export const settingsMessages = {
  "settings.accounts.current": "Active account",
  "settings.accounts.title": "Accounts",
  "settings.accounts.add": "Add account",
  "settings.accounts.rename": "Rename account",
  "settings.accounts.remove": "Remove account",
  "settings.accounts.global": "Accounts are shared globally by this OpenCode service.",
  "settings.accounts.active": "Active",
  "settings.accounts.label": "Account label",
  "settings.accounts.activate": "Use account",
  "settings.accounts.error": "Account operation failed. Refresh to reconcile the current state.",
  "settings.accounts.autoSelect": "Auto-select account",
  "settings.accounts.autoSelectHint": "Before the next send, at 100% Codex usage, select a verified available OAuth account. Selection is service-wide; failed requests are not replayed.",
  "settings.providers.models.title": "Models",
  "settings.websearch.title": "Web search",
  "settings.websearch.description": "Choose the search provider agents use to find information on the web. Changes are saved automatically.",
  "settings.websearch.global": "Default search",
  "settings.websearch.project": "For the current project",
  "settings.websearch.credentials": "Search provider API keys",
  "settings.websearch.credentialsHint": "Select a provider below to manage its API keys. Keys are shared by all projects on this OpenCode service. Saving a key does not change the search provider selected above.",
  "settings.websearch.environment": "From environment: {name} (read-only)",
  "settings.websearch.default": "Default / inherited",
  "settings.websearch.off": "Disabled",
  "settings.websearch.random": "Automatic provider",
  "settings.websearch.defaultHint": "Default uses inherited configuration or your previously saved OpenCode search choice. A Project override takes precedence over Global.",
  "settings.websearch.effective": "Search in this project: {provider}",
  "settings.websearch.error": "Unable to update or read web search settings. Refresh to retry.",
  "settings.opencode.setup.progress.install": "Installing OpenCode…",
  "settings.opencode.setup.elapsed": "Elapsed: {elapsed}",
  "settings.opencode.setup.keepOpen": "Downloading and installing can take several minutes. Keep CodeNomad open until setup finishes.",
  "settings.opencode.setup.installation_busy": "Another installation holds the OpenCode installation lock. Retry when it finishes. If it was interrupted, check the server log for the lock location.",
  "settings.opencode.setup.installation_in_use": "The OpenCode executable is in use or not writable. The update was deferred before changing the installation. Retry once the executable is available.",
  "settings.opencode.setup.source.path": "Executable found in the server's PATH.",
  "settings.opencode.setup.source.user": "User npm installation found outside the current PATH.",
  "settings.opencode.setup.sharedInstall": "Install for the user and configure PATH",
  "settings.opencode.setup.sharedInstallDescription": "Uses a standard npm installation shared with other clients. Open a new terminal after installation.",
  "settings.opencode.update.available": "OpenCode {version} is available.",
  "settings.opencode.setup.manage": "Manage OpenCode…",
  "settings.opencode.setup.connected": "OpenCode is connected.",
  "settings.opencode.setup.disconnected": "OpenCode is not connected.",
  "settings.opencode.setup.continue": "Continue",
  "settings.opencode.setup.diagnostics": "Version details",
  "settings.opencode.setup.troubleshooting": "Troubleshooting",
  "settings.opencode.setup.check": "Check status and updates",
  "settings.opencode.setup.checked": "Status and update check complete.",
  "settings.opencode.setup.reloaded": "OpenCode configuration reloaded.",
  "settings.opencode.setup.progress.start": "Connecting to OpenCode…",
  "settings.opencode.setup.progress.restart": "Restarting the shared service…",
  "settings.opencode.setup.progress.reload": "Reloading OpenCode configuration…",
  "settings.opencode.setup.actionFailed": "The OpenCode action could not be completed. Check the current status above and retry.",
  "settings.opencode.setup.reload": "Reload OpenCode configuration",
  "settings.opencode.setup.reloadDescription": "If installed plugins remain unavailable, reload configuration. This rebuilds every loaded location for all connected clients, cancels pending permissions and forms, and closes terminals and background commands. Active work may be interrupted.",
  "settings.opencode.setup.description": "Install, update and connect OpenCode on the server running your projects.",
  "settings.opencode.setup.missing": "OpenCode is not installed.",
  "settings.opencode.setup.update_required": "This OpenCode version is not supported by this CodeNomad release.",
  "settings.opencode.setup.ready": "The OpenCode executable is available.",
  "settings.opencode.setup.recommended": "Minimum recommended version",
  "settings.opencode.setup.untested": "OpenCode {version} has not been fully validated with this CodeNomad release. This alone does not prevent connecting.",
  "settings.opencode.setup.error": "The selected executable could not be verified.",
  "settings.opencode.setup.minimum": "Minimum version",
  "settings.opencode.setup.minimumReason": "OpenCode {version} introduced the native step-start timestamp required by the conversation display. Earlier versions need event conversions that have been removed.",
  "settings.opencode.setup.canonical_api": "The running service does not expose the session, permission, Form and inbox API required by this CodeNomad release.",
  "settings.opencode.setup.session_environment": "The running service cannot replace the session environment required before sending prompts or commands.",
  "settings.opencode.setup.daemon": "Running service",
  "settings.opencode.setup.install": "Install and start OpenCode",
  "settings.opencode.setup.connect": "Connect and continue",
  "settings.opencode.setup.restart": "Restart shared service",
  "settings.opencode.setup.restartRequired": "The running service needs updating. Restart interrupts active work in all connected OpenCode clients.",
  "settings.opencode.setup.restartAvailable": "A newer version is installed. You can keep using the running service and restart later. Restart interrupts active work in all connected OpenCode clients.",
  "settings.opencode.setup.serviceError": "Cannot verify the shared service. Check connection and authentication, then retry.",
  "settings.opencode.setup.manual": "Select a supported executable or install @opencode/cli on the execution host, then retry.",
  "settings.opencode.setup.wsl": "This executable runs inside WSL. Install or update OpenCode inside the selected distribution.",
  "settings.opencode.setup.chooseBinary": "Choose executable",
  "settings.opencode.setup.required": "OpenCode setup required",
  "settings.appearance.palette.mode": "Appearance mode",
  "settings.appearance.palette.auto": "Auto",
  "settings.appearance.palette.independent": "Save a palette for each appearance. Auto follows the system and shows the matching palette.",
  "settings.appearance.palette.soft": "Soft tones",
  "settings.appearance.palette.legacy": "Original palettes",
  "settings.appearance.palette.mist": "Mist",
  "settings.appearance.palette.mist.description": "Soft neutral grays with a cool undertone.",
  "settings.appearance.palette.slate": "Slate",
  "settings.appearance.palette.slate.description": "Blue-gray surfaces and restrained mineral accents.",
  "settings.appearance.palette.clay": "Clay",
  "settings.appearance.palette.clay.description": "Warm earth grays and muted ochre tones.",
  "settings.appearance.palette.linen": "Linen",
  "settings.appearance.palette.linen.description": "Soft ivory paper with gray-green text.",
  "settings.appearance.palette.iris": "Iris",
  "settings.appearance.palette.iris.description": "Cool lavender-gray surfaces without bright white.",
  "settings.appearance.palette.sage": "Sage",
  "settings.appearance.palette.sage.description": "Quiet gray-green surfaces and olive undertones.",
  "settings.appearance.palette.saved": "Saved customization",
  "instanceServiceStatus.sections.lsp": "LSP Servers",
  "instanceServiceStatus.sections.mcp": "MCP Servers",
  "instanceServiceStatus.sections.plugins": "Plugins",
  "instanceServiceStatus.lsp.loading": "Loading LSP servers...",
  "instanceServiceStatus.lsp.empty": "No LSP servers detected.",
  "instanceServiceStatus.lsp.status.connected": "Connected",
  "instanceServiceStatus.lsp.status.error": "Error",
  "instanceServiceStatus.mcp.loading": "Loading MCP servers...",
  "instanceServiceStatus.mcp.empty": "No MCP servers detected.",
  "instanceServiceStatus.mcp.toggleAriaLabel": "Toggle {name} MCP server",
  "instanceServiceStatus.plugins.loading": "Loading plugins...",
  "instanceServiceStatus.plugins.empty": "No plugins available for activation.",
  "instanceServiceStatus.plugins.description": "V2 activation controls write ordered rules only. Installation, updates, and options remain in OpenCode configuration or the CLI.",
  "instanceServiceStatus.plugins.scope.legend": "Write the next rule to",
  "instanceServiceStatus.plugins.scope.global": "Global",
  "instanceServiceStatus.plugins.scope.global.detail": "All projects using this daemon",
  "instanceServiceStatus.plugins.scope.project": "Project",
  "instanceServiceStatus.plugins.scope.project.detail": "This active project location",
  "instanceServiceStatus.plugins.scope.unavailable": "Project controls are unavailable: the configuration target is shared with Global or resolves outside this project location.",
  "instanceServiceStatus.plugins.target.existing": "Rule target: {path}",
  "instanceServiceStatus.plugins.target.new": "Will create: {path}",
  "instanceServiceStatus.plugins.runtime.heading": "Runtime inventory",
  "instanceServiceStatus.plugins.runtime.active": "Active",
  "instanceServiceStatus.plugins.runtime.failed": "Failed",
  "instanceServiceStatus.plugins.runtime.inactive": "Not running",
  "instanceServiceStatus.plugins.runtime.empty": "No plugins are reported by the runtime.",
  "instanceServiceStatus.plugins.refresh": "Refresh plugin controls",
  "instanceServiceStatus.plugins.toggleAriaLabel": "Change activation rule for {name}",
  "instanceServiceStatus.plugins.globalOverridden": "A project rule overrides the global state here.",
  "instanceServiceStatus.plugins.source.package": "Package: {source}",
  "instanceServiceStatus.plugins.source.local": "Local source: {source}",
  "instanceServiceStatus.plugins.source.builtin": "Built into OpenCode",
  "instanceServiceStatus.plugins.source.sdk": "Provided by the SDK host",
  "instanceServiceStatus.plugins.ruleState.default": "Inherited",
  "instanceServiceStatus.plugins.ruleState.enabled": "Configured on",
  "instanceServiceStatus.plugins.ruleState.disabled": "Configured off",
  "instanceServiceStatus.plugins.toast.ruleSaved": "Saved the {scope} activation rule for {name}.",
  "instanceServiceStatus.plugins.toast.ruleUnchanged": "The {scope} activation rule for {name} is already current.",
  "instanceServiceStatus.plugins.toast.reloadNote": "It takes effect when the daemon reloads its configuration.",
  "instanceServiceStatus.plugins.errors.load": "Plugin activation controls could not be loaded.",
  "instanceServiceStatus.plugins.errors.refresh": "Refresh failed. The last known plugin state is still shown.",
  "instanceServiceStatus.plugins.errors.save": "The {scope} activation rule for {name} could not be saved.",
  "instanceServiceStatus.plugins.errors.forbidden": "This workspace is not allowed to change the {scope} location of {name}.",
  "instanceServiceStatus.plugins.errors.conflict": "The project or configuration changed while saving the {scope} rule for {name}. Refresh and try again.",
  "instanceServiceStatus.plugins.errors.invalidConfig": "The {scope} OpenCode configuration for {name} is malformed. It was not changed.",

  "permissionBanner.pendingRequests.one": "{count} pending request",
  "permissionBanner.pendingRequests.other": "{count} pending requests",
  "permissionBanner.detail.permission.one": "{count} permission",
  "permissionBanner.detail.permission.other": "{count} permissions",
  "permissionBanner.detail.question.one": "{count} question",
  "permissionBanner.detail.question.other": "{count} questions",
  "permissionBanner.detail.form.one": "{count} form",
  "permissionBanner.detail.form.other": "{count} forms",
  "permissionBanner.detail.wrapper": " ({detail})",

  "agentSelector.placeholder": "Select agent...",
  "agentSelector.badge.subagent": "subagent",
  "agentSelector.none": "None",
  "agentSelector.trigger.primary": "Agent: {agent}",

  "modelSelector.placeholder.search": "Search models...",
  "modelSelector.none": "None",
  "modelSelector.trigger.primary": "Model: {model}",
  "modelSelector.trigger.ariaLabel": "Model: {model}, provider: {provider}, ID: {id}",
  "modelSelector.favoritesOnly.toggle.ariaLabel": "Toggle favorites only",
  "modelSelector.favoritesOnly.showAll": "Show all models",
  "modelSelector.favorite.add": "Add to favorites",
  "modelSelector.favorite.remove": "Remove from favorites",
  "modelSelector.manageProviders": "Manage Providers",
  "modelSelector.unavailableModel": "{model} (unavailable)",
  "settings.providers.actions.manageModels": "Manage models",
  "settings.providers.modelVisibility.back": "Back to providers",
  "settings.providers.modelVisibility.title": "Models for {provider}",
  "settings.providers.modelVisibility.subtitle": "Choose which models CodeNomad shows in model selectors.",
  "settings.providers.modelVisibility.search.label": "Search provider models",
  "settings.providers.modelVisibility.search.placeholder": "Search by model name or ID...",
  "settings.providers.modelVisibility.count.visible": "{visible} of {total} visible",
  "settings.providers.modelVisibility.actions.showAll": "Show all",
  "settings.providers.modelVisibility.actions.hideAll": "Hide all",
  "settings.providers.modelVisibility.list.empty": "No models match this search.",
  "settings.providers.modelVisibility.list.label": "Models for {provider}",
  "settings.providers.modelVisibility.save.failed": "Failed to save model visibility.",

  "thinkingSelector.variant.default": "Default",
  "thinkingSelector.label": "Thinking: {variant}",

  "envEditor.title": "Environment Variables",
  "envEditor.count.one": "({count} variable)",
  "envEditor.count.other": "({count} variables)",
  "envEditor.fields.name.placeholder": "Variable name",
  "envEditor.fields.name.readOnlyTitle": "Variable name (read-only)",
  "envEditor.fields.value.placeholder": "Variable value",
  "envEditor.fields.secure.enabled": "Value masked (secure)",
  "envEditor.fields.secure.disabled": "Click to mask value",
  "envEditor.fields.secure.masked": "Value hidden (secure)",
  "envEditor.actions.remove.title": "Remove variable",
  "envEditor.actions.add.title": "Add variable",
  "envEditor.empty": "No environment variables configured. Add variables above to customize the OpenCode environment.",
  "envEditor.help": "Before each prompt or session command, CodeNomad applies this profile's variables to that conversation's local shell environment. Changes take effect on the next send. They are also passed when starting a stopped OpenCode service; an existing service is not restarted.",
  "envEditor.applyFailed": "Could not apply the profile environment. Nothing was sent. Check the variables and your OpenCode version, then try again.",

  "contextUsagePanel.headings.tokens": "Tokens",
  "contextUsagePanel.headings.context": "Context",
  "contextUsagePanel.labels.input": "Input",
  "contextUsagePanel.labels.output": "Output",
  "contextUsagePanel.labels.cost": "Cost",
  "contextUsagePanel.included": "Included",
  "contextUsagePanel.labels.totalInput": "Total In",
  "contextUsagePanel.labels.totalOutput": "Total Out",
  "contextUsagePanel.labels.totalCost": "Total Cost",
  "contextUsagePanel.labels.totalReasoning": "Total Reasoning",
  "contextUsagePanel.labels.used": "Used",
  "contextUsagePanel.labels.available": "Avail",
  "contextUsagePanel.unavailable": "--",

  "providerUsage.title": "Usage",
  "providerUsage.tooltip": "Usage and reset windows for the provider selected by the active session.",
  "providerUsage.noSession": "Select a session to view plan usage.",
  "providerUsage.loading": "Loading usage...",
  "providerUsage.unsupported": "Usage is not available for this provider.",
  "providerUsage.notConfigured": "No compatible subscription credential was found.",
  "providerUsage.unavailable": "Usage is temporarily unavailable.",
  "providerUsage.nativeCredentialApiUnavailable": "Usage requires OpenCode {version} or newer. Update OpenCode, then restart its service from Settings.",
  "providerUsage.unavailableValue": "--",
  "providerUsage.usedPercent": "{percent}% used",
  "providerUsage.resets": "Resets {time}",
  "providerUsage.progressLabel": "{window} plan usage",
  "providerUsage.windows.fiveHours": "5 hours",
  "providerUsage.windows.sevenDays": "7 days",
  "providerUsage.windows.sevenDaysSonnet": "7 days · Sonnet",
  "providerUsage.windows.sevenDaysOpus": "7 days · Opus",
  "providerUsage.windows.weekly": "Weekly",
  "providerUsage.windows.daily": "Daily",
  "providerUsage.windows.monthly": "Monthly",
  "providerUsage.windows.credits": "Credits",
  "providerUsage.windows.billingCycle": "Billing cycle",
  "providerUsage.windows.session": "Session",
  "providerUsage.windows.premium": "Premium requests",
  "providerUsage.windows.chat": "Chat",
  "providerUsage.windows.completions": "Completions",
  "providerUsage.windows.mcpTools": "MCP tools",

  "settings.title": "Settings",
  "settings.navigationAriaLabel": "Settings sections",
  "settings.close": "Close settings",
  "settings.content.eyebrow": "Workspace preferences",
  "settings.open.title": "Open settings",
  "settings.open.ariaLabel": "Open settings",
  "settings.nav.appearance": "Appearance",
  "settings.nav.general": "General",
  "settings.nav.chat": "Chat",
  "settings.nav.voice": "Voice",
  "settings.nav.connections": "Connections",
  "settings.nav.runtime": "Runtime",
  "settings.nav.advanced": "Advanced",
  "settings.nav.about": "About",
  "settings.general.language.subtitle": "Choose the language used throughout the application.",
  "settings.behavior.holdLongAssistantReplies.title": "Hold long assistant replies",
  "settings.behavior.holdLongAssistantReplies.subtitle": "Stop following automatically when a streaming reply grows beyond the viewport.",
  "settings.nav.notifications": "Notifications",
  "settings.nav.remote": "Remote Access",
  "settings.nav.speech": "Speech",
  "settings.nav.providers": "Providers",
  "settings.nav.opencode": "OpenCode",
  "settings.nav.configFiles": "Config Files",
  "settings.nav.info": "Info",
  "settings.scope.device": "This device",
  "settings.scope.server": "Server setting",
  "settings.common.enabled": "Enabled",
  "settings.common.disabled": "Disabled",
  "settings.section.appearance.title": "Appearance",
  "settings.section.appearance.subtitle": "Adjust how the app looks on this device.",
  "settings.appearance.theme.title": "Theme",
  "settings.appearance.theme.subtitle": "Choose the color mode used throughout the app.",
  "settings.appearance.theme.option.system": "Match your operating system setting",
  "settings.appearance.theme.option.light": "Use the light appearance",
  "settings.appearance.theme.option.dark": "Use the dark appearance",
  "settings.appearance.colorScheme.title": "Color scheme",
  "settings.appearance.colorScheme.subtitle": "Choose the palette used by clients connected to this CodeNomad server.",
  "settings.appearance.colorScheme.option.system": "System",
  "settings.appearance.colorScheme.option.light": "Light",
  "settings.appearance.colorScheme.option.porcelain": "Porcelain",
  "settings.appearance.colorScheme.option.dawn": "Dawn",
  "settings.appearance.colorScheme.option.parchment": "Parchment",
  "settings.appearance.colorScheme.option.codeNomadClassic": "Classic",
  "settings.appearance.colorScheme.option.basalt": "Basalt",
  "settings.appearance.colorScheme.option.fjord": "Fjord",
  "settings.appearance.colorScheme.option.lichen": "Lichen",
  "settings.appearance.colorScheme.option.velvet": "Velvet",
  "settings.appearance.colorScheme.option.ember": "Ember",
  "settings.appearance.colorScheme.option.custom": "Custom",
  "settings.appearance.colorScheme.description.system": "Follow your operating system appearance.",
  "settings.appearance.colorScheme.description.light": "A bright, neutral palette.",
  "settings.appearance.colorScheme.description.porcelain": "Soft neutral chrome with a crisp white workspace.",
  "settings.appearance.colorScheme.description.dawn": "Cool daylight surfaces with a clear blue accent.",
  "settings.appearance.colorScheme.description.parchment": "Warm paper surfaces with a restrained teal accent.",
  "settings.appearance.colorScheme.description.codeNomadClassic": "The original CodeNomad dark palette.",
  "settings.appearance.colorScheme.description.basalt": "Neutral charcoal with a cool blue accent.",
  "settings.appearance.colorScheme.description.fjord": "Deep blue-gray with a sea-green accent.",
  "settings.appearance.colorScheme.description.lichen": "Earthy green-gray with a moss accent.",
  "settings.appearance.colorScheme.description.velvet": "Deep plum with a warm peach accent.",
  "settings.appearance.colorScheme.description.ember": "Warm brown-black with a copper accent.",
  "settings.appearance.colorScheme.description.custom": "Build and save your own palette.",
  "settings.appearance.colorScheme.custom.appearance": "Custom appearance",
  "settings.appearance.colorScheme.custom.appearance.light": "Light",
  "settings.appearance.colorScheme.custom.appearance.dark": "Dark",
  "settings.appearance.colorScheme.custom.colors": "Colors",
  "settings.appearance.colorScheme.custom.field.surfaceBase": "Base",
  "settings.appearance.colorScheme.custom.field.surfaceSecondary": "Secondary",
  "settings.appearance.colorScheme.custom.field.surfaceMuted": "Muted",
  "settings.appearance.colorScheme.custom.field.borderBase": "Borders",
  "settings.appearance.colorScheme.custom.field.textPrimary": "Primary text",
  "settings.appearance.colorScheme.custom.field.textMuted": "Muted text",
  "settings.appearance.colorScheme.custom.field.accentPrimary": "Accent",
  "settings.appearance.colorScheme.custom.field.statusSuccess": "Success",
  "settings.appearance.colorScheme.custom.field.statusWarning": "Warning",
  "settings.appearance.colorScheme.custom.field.statusError": "Error",
  "settings.appearance.colorScheme.custom.field.userAccent": "User",
  "settings.appearance.colorScheme.custom.field.agentAccent": "Agent",
  "settings.appearance.colorScheme.custom.field.compactionAccent": "Compaction",
  "settings.appearance.colorScheme.custom.field.yoloAccent": "YOLO mode",
  "settings.appearance.colorScheme.custom.pickerAriaLabel": "Choose {name}",
  "settings.appearance.colorScheme.custom.valueAriaLabel": "Hex value for {name}",
  "settings.appearance.colorScheme.custom.warning.format": "Use uppercase colors in #RRGGBB format.",
  "settings.appearance.colorScheme.custom.reset": "Reset",
  "settings.appearance.colorScheme.custom.new": "New",
  "settings.appearance.colorScheme.custom.name": "Name",
  "settings.appearance.colorScheme.custom.delete": "Delete",
  "settings.appearance.colorScheme.custom.deleteConfirm": "Delete \"{name}\"?",
  "settings.appearance.colorScheme.custom.save": "Save",
  "settings.appearance.colorScheme.custom.saveError": "Could not save the palette.",
  "settings.appearance.startup.title": "Startup",
  "settings.appearance.startup.subtitle": "Choose what this device restores when CodeNomad starts.",
  "settings.appearance.startup.restore.title": "Restore previous state",
  "settings.appearance.startup.restore.subtitle": "Reopen workspace and sidecar tabs, active sessions, and unsent messages, and restore scroll positions, panel layout, window position, and zoom.",
  "settings.appearance.startup.clear.title": "Saved startup state",
  "settings.appearance.startup.clear.subtitle": "Remove saved tabs, drafts, scroll positions, and panel layout. CodeNomad and OpenCode data are not deleted.",
  "settings.appearance.startup.clear.action": "Clear saved state",
  "settings.appearance.startup.clearSuccess": "Saved startup state cleared.",
  "settings.appearance.startup.clearError": "Could not clear the saved startup state.",
  "settings.appearance.startup.updateError": "Could not update the startup restore setting.",
  "settings.section.notifications.title": "Notifications",
  "settings.section.notifications.subtitle": "Control OS-level notifications for session activity.",
  "settings.notifications.permission.granted": "Granted",
  "settings.notifications.permission.denied": "Denied",
  "settings.notifications.permission.default": "Not granted",
  "settings.notifications.permission.unsupported": "Unsupported",
  "settings.notifications.messages.unsupportedEnvironment": "OS notifications are not supported in this environment.",
  "settings.notifications.messages.permissionDenied": "Notification permission denied. Enable notifications in your system or browser settings.",
  "settings.notifications.messages.permissionNotGranted": "Notification permission not granted.",
  "settings.notifications.messages.unsupportedGeneral": "Notifications are not supported in this environment.",
  "settings.notifications.messages.permissionGranted": "Permission granted. You can now enable notifications.",
  "settings.notifications.messages.permissionRequestDenied": "Permission denied. You may need to enable notifications in your system or browser settings.",
  "settings.notifications.sessionStatus.title": "Session status notifications",
  "settings.notifications.sessionStatus.subtitle": "Receive alerts when sessions need your attention.",
  "settings.notifications.enable.title": "Enable notifications",
  "settings.notifications.enable.permission": "Permission: {permission}",
  "settings.notifications.requestPermission.title": "Request permission",
  "settings.notifications.requestPermission.subtitle": "Allow the app to send notifications on this device.",
  "settings.notifications.requestPermission.action": "Request",
  "settings.notifications.allowVisible.title": "Notify when the app is focused",
  "settings.notifications.allowVisible.subtitle": "Keep alerts enabled even while this window is visible.",
  "settings.notifications.unsupportedNote": "Notifications are not supported in this environment. The notifications control stays disabled.",
  "settings.notifications.events.title": "Notify me when",
  "settings.notifications.events.subtitle": "Choose which session events should send alerts.",
  "settings.notifications.events.needsInput": "Session needs input",
  "settings.notifications.events.idle": "Session becomes idle",
  "settings.notifications.status.enabled": "Notifications enabled",
  "settings.notifications.status.disabled": "Notifications disabled",
  "settings.notifications.status.unsupported": "Notifications unsupported",
  "settings.section.remote.title": "Remote Access",
  "settings.section.remote.subtitle": "Review how this server is exposed on your network and secure access credentials.",
  "settings.section.opencode.title": "OpenCode",
  "settings.section.opencode.subtitle": "Choose the OpenCode binary and environment used for new instances.",
  "settings.opencode.runtime.title": "Runtime",
  "settings.opencode.runtime.subtitle": "Configure which OpenCode binary new instances launch with.",
  "settings.opencode.logLevel.title": "OpenCode Log Level",
  "settings.opencode.logLevel.subtitle": "Control the log verbosity used when launching new OpenCode instances.",
  "settings.opencode.logLevel.selector.title": "Default log level",
  "settings.opencode.logLevel.selector.subtitle": "Choose how verbose new OpenCode instances should be.",
  "settings.opencode.logLevel.option.debug": "Debug",
  "settings.opencode.logLevel.option.info": "Info",
  "settings.opencode.logLevel.option.warn": "Warn",
  "settings.opencode.logLevel.option.error": "Error",
  "settings.opencode.update.title": "OpenCode version",
  "settings.opencode.update.subtitle": "Installed version of the configured OpenCode binary.",
  "settings.opencode.update.checking": "Reading installed version...",
  "settings.opencode.update.checkFailed": "Could not read the installed OpenCode version.",
  "settings.opencode.update.retry": "Try again",
  "settings.opencode.update.installed": "Installed version",
  "settings.opencode.update.upToDate": "OpenCode is up to date.",
  "settings.opencode.update.availableUnsupported": "OpenCode {version} is available. Automatic installation is not supported by OpenCode V2.",
  "settings.opencode.update.action": "Update to OpenCode {version}",
  "settings.opencode.update.updating": "Updating OpenCode...",
  "settings.opencode.update.requiresInstance": "Start a workspace with this binary to install the update.",
  "settings.opencode.update.success": "OpenCode {version} is installed. New instances will use the updated version.",
  "settings.opencode.update.failed": "The OpenCode update failed. Your installed version was not changed.",
  "settings.configFiles.title": "Config Files",
  "settings.configFiles.subtitle": "Edit allowlisted global configuration files on this server.",
  "settings.configFiles.selector.label": "File",
  "settings.configFiles.selector.placeholder": "Select config file",
  "settings.configFiles.actions.save": "Save",
  "settings.configFiles.actions.reload": "Reload",
  "settings.configFiles.state.unsaved": "Unsaved changes",
  "settings.configFiles.state.notCreated": "File will be created on save",
  "settings.configFiles.empty": "No config file selected.",
  "settings.configFiles.errors.loadList": "Failed to load config files.",
  "settings.configFiles.errors.loadContent": "Failed to load config file.",
  "settings.configFiles.errors.save": "Failed to save config file.",
  "settings.configFiles.toast.saveSuccess": "Config file saved.",
  "settings.configFiles.toast.saveError": "Failed to save config file.",
  "settings.configFiles.confirmDiscard.message": "Discard unsaved changes before continuing?",
  "settings.configFiles.confirmDiscard.confirmLabel": "Discard changes",
  "settings.configFiles.confirmDiscard.cancelLabel": "Keep editing",

  "settings.providers.title": "Provider Authentication",
  "settings.providers.target": "OpenCode instance: {workspace}",
  "settings.providers.subtitle": "Connect API keys or OAuth accounts for the active OpenCode instance.",
  "settings.providers.refresh": "Refresh",
  "settings.providers.selectProvider": "Select provider",
  "settings.providers.available.title": "Available Providers",
  "settings.providers.configured.title": "Configured Providers",
  "settings.providers.loading": "Loading provider authentication methods...",
  "settings.providers.empty.noInstance": "Start an OpenCode workspace before managing provider authentication.",
  "settings.providers.empty.noProviders": "No providers are available from this OpenCode instance.",
  "settings.providers.empty.noConfiguredProviders": "No providers are currently configured for this OpenCode instance.",
  "settings.providers.models.one": "{count} model",
  "settings.providers.models.other": "{count} models",
  "settings.providers.actions.connect": "Connect",
  "settings.providers.actions.disconnect": "Disconnect",
  "settings.providers.actions.remove": "Remove saved auth",
  "settings.providers.actions.close": "Close",
  "settings.providers.actions.continue": "Continue",
  "settings.providers.actions.working": "Working...",
  "settings.providers.method.title": "Authentication method",
  "settings.providers.method.subtitle": "Choose the flow OpenCode exposes for this provider.",
  "settings.providers.method.api": "API key",
  "settings.providers.method.oauth": "OAuth",
  "settings.providers.method.command": "Command",
  "settings.providers.method.mixed": "API key, OAuth, or command",
  "settings.providers.method.fallback": "API key",
  "settings.providers.status.available": "Available",
  "settings.providers.auth.title": "Connect {provider}",
  "settings.providers.auth.subtitle": "Authentication is saved inside the active OpenCode server.",
  "settings.providers.apiKey.label": "API key",
  "settings.providers.apiKey.placeholder": "Paste provider API key",
  "settings.providers.oauth.noPrompts": "This OAuth method does not need additional details before opening the browser.",
  "settings.providers.oauth.promptsUnsupported": "This OAuth method requires provider-specific prompt inputs that are not supported by the current SDK build.",
  "settings.providers.oauth.enterCode": "Complete the browser flow, then paste the authorization code.",
  "settings.providers.oauth.openPage": "Open authorization page",
  "settings.providers.oauth.openHere": "Open in this tab",
  "settings.providers.oauth.copyLink": "Copy link",
  "settings.providers.oauth.linkCopied": "Link copied",
  "settings.providers.oauth.popupBlocked": "Your browser may have blocked the authorization page. Use the actions above to continue the sign-in flow.",
  "settings.providers.oauth.popup.loadingTitle": "OpenCode authorization",
  "settings.providers.oauth.popup.loadingBody": "Preparing authorization page...",
  "settings.providers.oauth.codeLabel": "Authorization code",
  "settings.providers.oauth.codePlaceholder": "Paste code from provider",
  "settings.providers.oauth.submitCode": "Submit code",
  "settings.providers.oauth.waitingTitle": "Waiting for authorization",
  "settings.providers.oauth.cancelWait": "Cancel",
  "settings.providers.prompt.selectPlaceholder": "Select an option",
  "settings.providers.prompt.customValuesPlaceholder": "Additional values, separated by commas",
  "settings.providers.command.description": "OpenCode will run this provider's native authentication command.",
  "settings.providers.command.waitingTitle": "Waiting for command authentication",
  "settings.providers.command.waitingMessage": "Complete the instructions shown by the authentication command.",
  "settings.providers.success": "Provider authentication saved. Provider data has been refreshed.",
  "settings.providers.source.api": "Saved provider authentication",
  "settings.providers.source.config": "Configured in opencode.jsonc",
  "settings.providers.source.custom": "Configured by custom provider logic",
  "settings.providers.source.env": "Configured from environment variables",
  "settings.providers.source.unknown": "Configured provider source",
  "settings.providers.errors.loadFailed": "Failed to load provider authentication methods.",
  "settings.providers.errors.noAuthorization": "Provider did not return authorization data.",
  "settings.providers.errors.authorizationFailed": "Authorization failed.",
  "settings.providers.errors.removeFailed": "Failed to remove provider authentication.",
  "settings.providers.errors.envDisconnectUnavailable": "This provider is configured from environment variables and cannot be disconnected from the UI.",


  "settings.appearance.behavior.title": "Interaction",
  "settings.appearance.behavior.subtitle": "Control message, tool, diagnostics, and usage detail together.",
  "settings.behavior.expansionPresets.ariaLabel": "Transcript detail presets",
  "settings.behavior.expansionPreset.minimal.title": "Minimal",
  "settings.behavior.expansionPreset.minimal.description": "Keep most generated detail tucked away until needed.",
  "settings.behavior.expansionPreset.balanced.title": "Balanced",
  "settings.behavior.expansionPreset.balanced.description": "Show important actions while keeping noisy reads and fetches compact.",
  "settings.behavior.expansionPreset.detailed.title": "Detailed",
  "settings.behavior.expansionPreset.detailed.description": "Open most tool and thinking output for a fuller transcript.",
  "settings.behavior.expansionPreset.everything.title": "Everything",
  "settings.behavior.expansionPreset.everything.description": "Expand all tool and thinking output by default.",
  "settings.behavior.expansionPreset.custom.title": "Custom",
  "settings.behavior.expansionPreset.custom.description": "Your customized transcript detail defaults.",
  "settings.behavior.expansionDefaults.title": "Expansion defaults",
  "settings.behavior.expansionDefaults.itemColumn": "Item",
  "settings.behavior.expansionDefaults.stateColumn": "Default state",
  "settings.behavior.expansionDefaults.thinking": "thinking",
  "settings.behavior.expansionDefaults.otherTools": "Other",
  "settings.behavior.expansionDefaults.rowAriaLabel": "Default state for {item}",
  "settings.behavior.keyboardHints.title": "Keyboard shortcut hints",
  "settings.behavior.keyboardHints.subtitle": "Show keyboard shortcut hints across the UI.",
  "settings.behavior.thinking.title": "Thinking sections",
  "settings.behavior.thinking.subtitle": "Show or hide AI thinking sections in messages.",
  "settings.behavior.thinkingDefault.title": "Thinking default",
  "settings.behavior.thinkingDefault.subtitle": "Choose whether thinking sections start expanded or collapsed.",
  "settings.behavior.messageTimeline.title": "Message timeline",
  "settings.behavior.messageTimeline.subtitle": "Show or hide the message timeline sidebar.",
  "settings.behavior.timelineTools.title": "Timeline tool calls",
  "settings.behavior.timelineTools.subtitle": "Show or hide tool call entries in the message timeline.",
  "settings.behavior.diffView.title": "Diff view",
  "settings.behavior.diffView.subtitle": "Choose how tool-call diffs are displayed.",
  "settings.behavior.diffView.option.split": "Split",
  "settings.behavior.diffView.option.unified": "Unified",
  "settings.behavior.toolOutputsDefault.title": "Tool outputs default",
  "settings.behavior.toolOutputsDefault.subtitle": "Choose whether tool outputs start expanded or collapsed.",
  "settings.behavior.diagnosticsDefault.title": "Diagnostic",
  "settings.behavior.diagnosticsDefault.subtitle": "Choose whether diagnostics output starts expanded or collapsed.",
  "settings.behavior.toolInputsVisibility.title": "Input",
  "settings.behavior.toolInputsVisibility.subtitle": "Set default visibility for tool call input arguments.",
  "settings.behavior.usageMetrics.title": "Tokens",
  "settings.behavior.usageMetrics.subtitle": "Show or hide token and cost stats for assistant messages.",
  "settings.behavior.providerUsageCreditBalance.title": "Provider credit balance",
  "settings.behavior.providerUsageCreditBalance.subtitle": "Show supplemental provider credit balances in the Usage panel.",
  "settings.behavior.autoCleanup.title": "Auto-cleanup blank sessions",
  "settings.behavior.autoCleanup.subtitle": "Automatically clean up blank sessions when creating new ones.",
  "settings.behavior.keepUnseenSubagentIdle.title": "Keep subagent idle markers",
  "settings.behavior.keepUnseenSubagentIdle.subtitle": "Keep subagent idle markers visible until viewed instead of hiding them after 5 seconds.",
  "settings.behavior.focusExistingWindowOnSecondLaunch.title": "Focus existing window on second launch",
  "settings.behavior.focusExistingWindowOnSecondLaunch.subtitle": "Bring the most recently used CodeNomad window forward instead of opening a new one.",
  "settings.behavior.promptVoiceInput.title": "Prompt voice input",
  "settings.behavior.promptVoiceInput.subtitle": "Show the microphone control for speech-to-text prompt input when speech is configured.",
  "settings.behavior.promptSubmit.title": "Enter to submit",
  "settings.behavior.promptSubmit.subtitle": "Use Enter to submit prompts; Cmd/Ctrl+Enter inserts a new line.",
  "settings.behavior.followUpBehavior.title": "Follow-up behavior",
  "settings.behavior.followUpBehavior.subtitle": "Choose how prompts are delivered while a task is active; Cmd/Ctrl+Shift+Enter uses the other behavior.",
  "settings.behavior.followUpBehavior.option.steer": "Steer",
  "settings.behavior.followUpBehavior.option.queue": "Queue",
  "settings.speech.title": "Speech",
  "settings.speech.subtitle": "Configure speech-to-text now and text-to-speech groundwork for later features.",
  "settings.speech.provider.title": "Provider",
  "settings.speech.provider.subtitle": "Speech requests use the server-side speech adapter.",
  "settings.speech.provider.openaiCompatible": "OpenAI-compatible",
  "settings.speech.status.loading": "Checking configuration...",
  "settings.speech.status.configured": "Configured",
  "settings.speech.status.missing": "Missing API key",
  "settings.speech.status.partial": "Partially configured",
  "settings.speech.status.error": "Speech service unavailable",
  "settings.speech.apiKey.title": "API key",
  "settings.speech.apiKey.subtitle": "Used for CodeNomad-managed speech requests.",
  "settings.speech.apiKey.placeholder": "Enter a new API key",
  "settings.speech.apiKey.storedNote": "A saved API key is hidden. Enter a new value to replace it, or leave the field blank to keep it.",
  "settings.speech.apiKey.clearAction": "Clear saved key",
  "settings.speech.apiKey.clearPending": "The saved API key will be removed when you save.",
  "settings.speech.baseUrl.title": "Base URL",
  "settings.speech.baseUrl.subtitle": "Optional override for OpenAI-compatible speech endpoints.",
  "settings.speech.baseUrl.placeholder": "https://api.openai.com/v1",
  "settings.speech.sttModel.title": "Transcription model",
  "settings.speech.sttModel.subtitle": "Model used for prompt speech-to-text requests.",
  "settings.speech.ttsModel.title": "Speech model",
  "settings.speech.ttsModel.subtitle": "Default text-to-speech model reserved for future playback features.",
  "settings.speech.ttsVoice.title": "Default voice",
  "settings.speech.ttsVoice.subtitle": "Default text-to-speech voice reserved for future playback features.",
  "settings.speech.playbackMode.title": "Playback mode",
  "settings.speech.playbackMode.subtitle": "Choose whether TTS starts playing as audio streams in or after the full file is generated.",
  "settings.speech.playbackMode.streaming": "Streaming",
  "settings.speech.playbackMode.buffered": "Buffered",
  "settings.speech.ttsFormat.title": "Output format",
  "settings.speech.ttsFormat.subtitle": "Choose the audio format for synthesized speech. Streaming support depends on your provider and browser.",
  "settings.speech.help": "Prompt voice input appears when speech transcription is configured and supported. Message playback uses the TTS mode and format selected here.",
  "settings.speech.compatibility.streamingUnavailable": "Your current speech provider configuration does not advertise streaming TTS. Switch playback mode to buffered if you want playback to work now.",
  "settings.speech.compatibility.browserStreamingUnavailable": "Your current browser cannot stream the selected TTS format. Choose buffered playback or switch to a different format.",
  "settings.speech.compatibility.runtimeNote": "All formats stay selectable in streaming mode. Some browser and provider combinations may still fail at playback time.",
  "settings.speech.testPlayback.action": "Test playback",
  "settings.speech.testPlayback.generating": "Generating sample",
  "settings.speech.testPlayback.stop": "Stop sample",
  "settings.speech.testPlayback.sample": "Thank you for using CodeNomad, your speech settings are working fine.",
  "settings.speech.testPlayback.note": "The test uses your current playback mode and format immediately. Save API key, base URL, model, or voice changes first if you want those reflected too.",
  "settings.speech.testInput.action": "Test input",
  "settings.speech.testInput.stop": "Stop recording",
  "settings.speech.testInput.transcribing": "Transcribing",
  "settings.speech.testInput.requesting": "Starting…",
  "settings.speech.testInput.empty": "No speech detected",
  "settings.speech.save.action": "Save",
  "settings.speech.save.saving": "Saving...",
  "settings.speech.save.saved": "Saved",
  "settings.speech.save.unsaved": "Unsaved changes",
  "settings.speech.save.error": "Save failed",
  "settings.speech.separateProviders.title": "Separate providers for input and output",
  "settings.speech.separateProviders.subtitle": "Use different API keys and endpoints for voice input (STT) and output (TTS).",
  "settings.speech.stt.section.title": "Voice Input (Speech-to-Text)",
  "settings.speech.tts.section.title": "Voice Output (Text-to-Speech)",
  "settings.speech.stt.apiKey.title": "Input API key",
  "settings.speech.stt.apiKey.subtitle": "Used for speech-to-text transcription requests.",
  "settings.speech.stt.apiKey.placeholder": "Enter a new input API key",
  "settings.speech.stt.apiKey.storedNote": "A saved input API key is hidden. Enter a new value to replace it, or leave the field blank to keep it.",
  "settings.speech.stt.apiKey.usingShared": "Using the shared API key. Enter a new key to override.",
  "settings.speech.stt.apiKey.clearAction": "Clear saved input key",
  "settings.speech.stt.apiKey.clearPending": "The saved input API key will be removed when you save.",
  "settings.speech.stt.baseUrl.title": "Input base URL",
  "settings.speech.stt.baseUrl.subtitle": "OpenAI-compatible endpoint for transcription requests.",
  "settings.speech.stt.baseUrl.placeholder": "https://api.openai.com/v1",
  "settings.speech.stt.model.title": "Input model",
  "settings.speech.stt.model.subtitle": "Model used for speech-to-text.",
  "settings.speech.tts.apiKey.title": "Output API key",
  "settings.speech.tts.apiKey.subtitle": "Used for text-to-speech synthesis requests.",
  "settings.speech.tts.apiKey.placeholder": "Enter a new output API key",
  "settings.speech.tts.apiKey.storedNote": "A saved output API key is hidden. Enter a new value to replace it, or leave the field blank to keep it.",
  "settings.speech.tts.apiKey.usingShared": "Using the shared API key. Enter a new key to override.",
  "settings.speech.tts.apiKey.clearAction": "Clear saved output key",
  "settings.speech.tts.apiKey.clearPending": "The saved output API key will be removed when you save.",
  "settings.speech.tts.baseUrl.title": "Output base URL",
  "settings.speech.tts.baseUrl.subtitle": "OpenAI-compatible endpoint for synthesis requests.",
  "settings.speech.tts.baseUrl.placeholder": "https://api.openai.com/v1",
  "settings.speech.tts.model.title": "Output model",
  "settings.speech.tts.model.subtitle": "Model used for text-to-speech.",
  "settings.nav.sidecars": "SideCars",
  "settings.section.sidecars.eyebrow": "Server services",
  "settings.section.sidecars.title": "SideCars",
  "settings.section.sidecars.subtitle": "Configure local services listening on fixed ports that the server can proxy into tabs.",
  "sidecars.form.name": "Name",
  "sidecars.form.validation": "Enter a valid SideCar name and port.",
  "sidecars.form.port": "Port",
  "sidecars.form.insecure": "Use HTTP",
  "sidecars.form.protocol": "Protocol",
  "sidecars.form.protocol.help": "Choose how the proxy should connect to the local service.",
  "sidecars.form.protocol.https": "HTTPS",
  "sidecars.form.protocol.http": "HTTP",
  "sidecars.form.prefixMode": "Prefix mode",
  "sidecars.form.prefixMode.help": "Choose whether the SideCar receives the public /sidecars path prefix.",
  "sidecars.form.prefixMode.strip": "Strip prefix",
  "sidecars.form.prefixMode.preserve": "Preserve prefix",
  "sidecars.form.add": "Add SideCar",
  "sidecars.kind.port": "Port",
  "sidecars.status.running": "Running",
  "sidecars.status.stopped": "Stopped",
  "sidecars.basePath": "Base path",
  "sidecars.settings.listTitle": "Configured SideCars",
  "sidecars.settings.listSubtitle": "Review the port-based SideCars available in the picker.",
  "sidecars.settings.empty": "No SideCars configured yet.",
  "sidecars.picker.title": "Open SideCar",
  "sidecars.picker.loading": "Loading SideCars...",
  "sidecars.picker.subtitle": "Choose an available SideCar to open in a new tab.",
  "sidecars.picker.empty": "No port-based SideCars are available yet.",
  "sidecars.picker.close": "Close",
  "sidecars.open.errorTitle": "Unable to open SideCar",
  "sidecars.open.notFound": "SideCar not found.",
  "sidecars.open.notRunning": "SideCar is not reachable on its configured port.",
  "sidecars.back": "Back",
  "sidecars.refresh": "Refresh",
  "sidecars.path": "Path",
  "sidecars.go": "Go",

  // Toast History Panel
  "toastHistory.title": "Notification History",
  "toastHistory.empty": "No notifications yet",
  "toastHistory.empty.filter": "No matching notifications for this filter",
  "toastHistory.clearAll": "Clear all",
  "toastHistory.markAllRead": "Mark all read",
  "toastHistory.filter.label": "Filter notifications",
  "toastHistory.filter.all": "All",
  "toastHistory.filter.info": "Info",
  "toastHistory.filter.success": "Success",
  "toastHistory.filter.warning": "Warning",
  "toastHistory.filter.error": "Error",
  "toastHistory.today": "Today",
  "toastHistory.yesterday": "Yesterday",
  "toastHistory.earlier": "Earlier",
  "toastHistory.unread": "{count} unread",
  "toastHistory.viewSettings": "Settings",
  "toastHistory.close": "Close",
  "toastHistory.openLinkError": "Unable to open link",
  "toastHistory.deleteItem": "Delete notification",

  // Info Section
  "settings.section.info.title": "About",
  "settings.section.info.subtitle": "View version, runtime, and gather diagnostic information.",
  "settings.info.version.server": "Server version",
  "settings.info.version.ui": "UI version",
  "settings.info.version.uiSource": "UI source",
  "settings.info.runtime.type": "Client runtime",
  "settings.info.runtime.platform": "Client platform",
  "settings.info.runtime.os": "Client operating system",
  "settings.info.server.os": "Server operating system",
  "settings.info.server.arch": "Server architecture",
  "settings.info.server.url": "Server URL",
  "settings.info.server.root": "Workspace root",
  "settings.info.runtime.windowContext": "Window context",
  "settings.info.diagnostics.reportTitle": "CodeNomad Diagnostic Report",
  "settings.info.diagnostics.generated": "Generated",
  "settings.info.connectivity.title": "CodeNomad server connectivity",
  "settings.info.connectivity.subtitle": "Inspect the effective listener configuration and candidate network addresses.",
  "settings.info.connectivity.mode.local": "Local only",
  "settings.info.connectivity.mode.all": "All network interfaces",
  "settings.info.connectivity.mode.specific": "Specific network interface",
  "settings.info.connectivity.host": "Bind host",
  "settings.info.connectivity.localListener": "Local listener",
  "settings.info.connectivity.remoteListener": "Remote listener",
  "settings.info.connectivity.disclaimer": "These addresses are derived from network interfaces. Firewall, router, and certificate settings may still prevent connections.",
  "settings.info.connectivity.loadFailed": "Unable to load CodeNomad server connectivity details.",
  "settings.info.diagnostics.privacy": "Review this report before sharing it. It includes local paths and network addresses, but never passwords or authentication secrets.",
  "settings.info.updates.title": "Updates",
  "settings.info.updates.subtitle": "Check for new releases of CodeNomad.",
  "settings.info.updates.latest": "Latest version",
  "settings.info.updates.download": "Download update",
  "settings.info.updates.refresh": "Refresh",
  "settings.info.diagnostics.copyFailed": "Clipboard access denied. Use the download button instead.",
  "settings.info.diagnostics.title": "Diagnostics",
  "settings.info.diagnostics.subtitle": "Collect system and version info for bug reports.",
  "settings.info.diagnostics.copy": "Copy to clipboard",
  "settings.info.diagnostics.download": "Download .txt",
  "settings.info.diagnostics.copied": "Diagnostic info copied to clipboard.",
} as const
